import { POWERED_BY } from '@pairing/core/brand';
import { PairingMark } from './PairingMark';
import styles from './brand.module.css';

/** The footer every tenant's portal carries (ADR D17), whatever its own branding. */
export function PoweredBy() {
  return (
    <p className={styles.poweredBy}>
      <PairingMark variant="light" height={17} decorative />
      <span>{POWERED_BY}</span>
    </p>
  );
}
